const routes = [
    {
        path: "/graduate/application/quotas",
        component: () => import("../pages/Index"),
        meta: {
            isAuthenticated: true,
            permission: "graduateapplicationquota_index"
        }
    }
]

export default routes;
